const crypto = require('crypto');

const aes256Encrypt = (str) => {
  const algo = "aes-256-cbc";
  const key = "16elxRFB7DYPSSi1G4uWj1UqCeQGF473";
  const iv = crypto.randomBytes(16);

  const cipher = crypto.createCipheriv(algo, Buffer.from(key), iv);

  let encrypted = cipher.update(str);
  encrypted = Buffer.concat([encrypted, cipher.final()]);

  return iv.toString("hex") + encrypted.toString("hex");
}

module.exports = {
  aes256Encrypt,
}
